import Box from '@mui/joy/Box';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import HomeIcon from '@mui/icons-material/Home';
import { Section, PrimaryButton } from '../components/ui';
import usePageMeta from '../hooks/usePageMeta';
import './styles/NotFound.css';

const NotFound = () => {
  usePageMeta(
    'Page Not Found',
    'This page doesn’t exist. Head back to the New Horizon Vineyard home page to find ' +
      'service times, ministries, and sermons.',
  );

  return (
    <Box component="main" className="notfound-wrap">
      <Section bg="default" padding="lg" maxWidth="md">
        <Stack spacing={3} sx={{ alignItems: 'center', textAlign: 'center' }}>
          <Typography
            level="display"
            sx={{ color: 'primary.500', fontWeight: 800, lineHeight: 1 }}
          >
            404
          </Typography>
          <Typography level="h2" sx={{ color: 'text.primary' }}>
            Sorry, this page doesn’t exist
          </Typography>
          <Typography level="body-lg" sx={{ color: 'text.secondary', maxWidth: 560 }}>
            But Jesus does. “Ask and it will be given to you; seek and you will find; knock and
            the door will be opened to you.” Matthew 7:7
          </Typography>
          <PrimaryButton to="/" startDecorator={<HomeIcon />}>
            Back to Home
          </PrimaryButton>
        </Stack>
      </Section>
    </Box>
  );
};

export default NotFound;
